// ══════════════════════════════════════════════════════════════
// COMPASS – Fund State Model
// ══════════════════════════════════════════════════════════════
import { FundDto } from '../../api/models/fund-dto';

export interface FundState {
  funds: FundDto[];
  selectedFund: FundDto | null;
  loading: boolean;
  saving: boolean;
  error: string | null;
}

export const initialFundState: FundState = {
  funds: [],
  selectedFund: null,
  loading: false,
  saving: false,
  error: null,
};
